import axios from "axios";
import Configuration from "./Config/Config";

axios.interceptors.request.use((config) => {
  const requestUrl = new URL(config.url, config.baseURL || window.location.origin);
  const apiOrigins = [Configuration.urlApi, Configuration.urlGraphQl]
    .filter(Boolean)
    .map((url) => new URL(url, window.location.origin).origin);

  if (apiOrigins.includes(requestUrl.origin)) {
    config.headers = config.headers || {};
    config.headers["x-api-key"] = Configuration.X_API_KEY;
  }

  return config;
});

export default axios;
